import { BatteryEventKind, type BatteryHistoryEntry, type Valve } from "@eisox/api/core-api";
import dayjs from "@eisox/dayjs";
import { Dialog } from "@eisox/design-system";
import { HistoryIcon } from "@eisox/icons";

import { valveApi } from "~/api";
import { m } from "~/paraglide/messages";

import { ValveHistoryTable } from "./valve-history-table";

const formatInfo = (entry: BatteryHistoryEntry): string => {
  const b = entry.batZ ?? "-";
  switch (entry.kind) {
    case BatteryEventKind.LOW:
      return m.battery_low({ b });
    case BatteryEventKind.NEW:
      return m.battery_new({ b });
    default:
      return m.battery_measure({ b });
  }
};

interface BatteryHistoryDialogProps extends Dialog.RootProps {
  buildingId: string;
  valve: Pick<Valve, "id">;
}

export const BatteryHistoryDialog: React.FC<BatteryHistoryDialogProps> = ({
  buildingId,
  valve,
  children,
  ...props
}) => (
  <Dialog.Root {...props}>
    {children ? <Dialog.Trigger asChild>{children}</Dialog.Trigger> : null}
    <Dialog.Content
      title={m.battery_history()}
      icon={<HistoryIcon />}
      className="gap-4 md:gap-6 flex h-[85dvh] max-h-[900px] w-full flex-col min-[992px]:w-[80%] min-[1200px]:w-[70%] min-[1400px]:w-[60%]"
    >
      <ValveHistoryTable<BatteryHistoryEntry>
        columns={[
          { id: "date", header: m.date(), widthPercent: 33, cell: entry => dayjs(entry.date).format("L LT") },
          { id: "info", header: m.information(), widthPercent: 33, cell: formatInfo },
          {
            id: "softwareVersion",
            header: m.software_version(),
            widthPercent: 34,
            cell: entry => entry.softwareVersion,
          },
        ]}
        query={filters => valveApi.queries.batteryHistory(buildingId, valve.id, filters)}
      />
    </Dialog.Content>
  </Dialog.Root>
);
